


























































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { ProviderArr } from "@/data/BusinessTypes";

@Component({
    ...mapGetters(["accountBook"])
})
export default class envInvoice extends Vue {
    @Prop({ type: [Object, Array] })
    data!: Envidence;

    getType(type: string) {
        switch (type) {
            case "0":
                return "普通发票";
            case "1":
                return "专业发票";
            case "2":
                return "电子发票";
            default:
                return "普通发票";
        }
    }
    // 预览图片
    previewImage() {
        (<any>this.$refs.image).clickHandler();
    }
    getBusyType(val: number) {
        return ProviderArr[val];
    }
}
